import React from 'react';
import { FAQ_BY_PATH } from './faqData';
import './FaqSection.css';

/**
 * Visible FAQ block. Google only permits FAQPage structured data where the same
 * questions and answers are visible on the page, so this component and the JSON-LD
 * in SeoManager both read from FAQ_BY_PATH.
 *
 * Rendered with plain <details>/<summary> so the answer text is present in the DOM
 * (and in the prerendered HTML) even when collapsed - a JS-driven accordion that
 * only mounts the answer on click would hide it from crawlers.
 */
const FaqSection: React.FC<{ path: string; heading?: string }> = ({
  path,
  heading = 'Frequently asked questions',
}) => {
  const faq = FAQ_BY_PATH[path];
  if (!faq || faq.length === 0) return null;

  return (
    <section className="faq-section" aria-labelledby="faq-heading">
      <div className="container">
        <h2 id="faq-heading" className="faq-heading">
          {heading}
        </h2>
        <div className="faq-list">
          {faq.map((item) => (
            <details key={item.q} className="faq-item">
              <summary className="faq-question">{item.q}</summary>
              <div className="faq-answer">
                <p>{item.a}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FaqSection;
